import { prepareArticles } from './allArticlesMapper'
import { toArticle } from './blogMapper'
import {
  GetPosts,
  Article,
  GetPost,
  GetAllArticles,
  GetPostsSlugsByProperty,
} from './types'
import { api } from '..'

export const getPost: GetPost = async (slug) => {
  const { data: axiosData } = await api.get(`/articles/${slug}?populate=deep`)
  const { data } = axiosData

  return {
    article: toArticle(data),
    recommendedArticles: data.attributes.recommendedArticles.data.map(
      (recommendedArticle: any) => toArticle(recommendedArticle),
    ),
    recommendedArticlesTitle:
      data.attributes.recommendedArticlesTitle || 'Leia também:',
  }
}

export const getCategories = async () => {
  const { data: axiosData } = await api.get(`/tags?locale=pt-BR&populate=deep`)
  const { data } = axiosData

  return data.map((category: any) => category.attributes.value)
}

export const getAllArticles: GetAllArticles = async () => {
  const { data: axiosData } = await api.get(`/articles/all`)
  const { data } = axiosData

  return data?.map((article: any) => ({
    recommendedArticlesTitle: article.attributes.recommendedArticlesTitle,
    recommendedArticles: article.attributes.recommendedArticles.data.map(
      (recommendedArticle: any) => toArticle(recommendedArticle),
    ),
    article: toArticle(article),
  }))
}

export const getPosts: GetPosts = async () => {
  const [{ data: axiosData }, { data: returnAllArticles }] = await Promise.all([
    api.get(`/page-blog?locale=pt-BR&populate=deep`),
    api.get('/articles/all'),
  ])
  const { data: pageBlogData } = axiosData
  const { data: allArticles } = returnAllArticles as any

  const { data: articleHighlightData } = pageBlogData?.attributes?.blogHighlight
    ?.article as any
  const text = pageBlogData?.attributes?.text as any
  const seo = pageBlogData?.attributes?.seo as any

  const articleHighlight: Article = toArticle(articleHighlightData)

  const sortedAndFilteredArticles = prepareArticles(allArticles)
  const articles: Article[] = sortedAndFilteredArticles.map(
    (article: any): Article => toArticle(article),
  )

  return {
    articleHighlight,
    articles,
    text,
    seo,
  }
}

export const updateAmountVisitors = async (slug: string) => {
  await api.put(`/articles/visitors/${slug}`)
}

export const getPostsSlugsByProperty: GetPostsSlugsByProperty = async (
  property: string,
  id: number,
) => {
  const { data: axiosData } = await api.get(
    `articles?filters[${property}][id][$eq]=${id}`,
  )

  const { data } = axiosData

  return data?.map((article: any) => article.attributes.slug as string)
}
